// ── Formatter helpers ─────────────────────────────────────────────────────────

export function fmt(n?: number | null, locale = "ru-RU"): string {
  if (n == null) return "—";
  return n.toLocaleString(locale);
}

export function fmtDate(iso: string, locale = "ru-RU"): string {
  return new Date(iso).toLocaleDateString(locale, {
    day: "numeric", month: "short", year: "numeric",
  });
}

export function fmtPct(n?: number | null, locale = "ru-RU"): string {
  if (n == null) return "—";
  const sep = locale.startsWith("ru") ? "," : ".";
  return n.toFixed(2).replace(".", sep) + " %";
}

export function fmtWatchTime(ms: number | null | undefined, secLabel: string): string {
  if (ms == null) return "—";
  return `${(ms / 1000).toFixed(1)} ${secLabel}`;
}

export function fmtTotalWatchTime(ms: number | null | undefined, secLabel: string, minLabel: string): string {
  if (ms == null) return "—";
  const mins = ms / 1000 / 60;
  return mins >= 1 ? `${mins.toFixed(1)} ${minLabel}` : `${(ms / 1000).toFixed(0)} ${secLabel}`;
}

export function fmtSkipRate(rate: number | null | undefined, locale = "ru-RU"): string {
  if (rate == null) return "—";
  const sep = locale.startsWith("ru") ? "," : ".";
  return (rate * 100).toFixed(1).replace(".", sep) + " %";
}

export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null) return "—";
  const totalSec = Math.floor(ms / 1000);
  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

// ── Indicator ─────────────────────────────────────────────────────────────────

export type IndicatorLevel = "green" | "yellow" | "red" | "none";

export interface Indicator {
  level: IndicatorLevel;
  label: string;
  tooltip: string;
}

export function getIndicator(metric: string, value: number | null | undefined): Indicator {
  if (value == null) return { level: "none", label: "—", tooltip: "" };
  let level: IndicatorLevel;
  switch (metric) {
    case "er":
      level = value >= 3 ? "green" : value >= 1 ? "yellow" : "red"; break;
    case "err":
      level = value >= 5 ? "green" : value >= 2 ? "yellow" : "red"; break;
    case "like_rate":
      level = value >= 2 ? "green" : value >= 0.5 ? "yellow" : "red"; break;
    case "comment_rate":
      level = value >= 0.3 ? "green" : value >= 0.1 ? "yellow" : "red"; break;
    case "views":
      level = value >= 500 ? "green" : value >= 100 ? "yellow" : "red"; break;
    case "avg_watch_time_sec":
      level = value >= 15 ? "green" : value >= 7 ? "yellow" : "red"; break;
    case "reach_rate":
      level = value >= 10 ? "green" : value >= 3 ? "yellow" : "red"; break;
    case "skip_rate":
      // чем ниже — тем лучше
      level = value <= 0.3 ? "green" : value <= 0.6 ? "yellow" : "red"; break;
    default:
      return { level: "none", label: "—", tooltip: "" };
  }
  return {
    level,
    label: `report.indicators.${level === "green" ? "excellent" : level === "yellow" ? "normal" : "low"}`,
    tooltip: `report.indicators.${metric}.${level}`,
  };
}

// ── Media type ────────────────────────────────────────────────────────────────

export function mediaTypeLabelKey(type: string): string {
  if (type === "VIDEO") return "report.typeReel";
  if (type === "IMAGE") return "report.typePhoto";
  if (type === "CAROUSEL_ALBUM") return "report.typeCarousel";
  return type;
}
